import store from "../store/index";

const Seat = {};

let _orderHoursMax = sessionStorage.getItem('config_seat_maxh');
let _orderHoursMaxIdx = parseInt(_orderHoursMax) * 2;
let _orderHoursMin = sessionStorage.getItem('config_seat_minh');
let _orderHoursMinIdx = parseInt(_orderHoursMin) * 2;
let openHourJsonData;
let _NOW = new Date,_DELAY = 4; //预约都是加4个小时
let errorTip = "当前没有时间可以选择";


Seat.loadStartTime = function (obj,succ) {
  let orderDate = obj.orderDate;
  let type = 1;
  let openHourJsonData = obj.openHourJsonData;
  
  var week = getMyDay(orderDate);
  var t = [];
  if (type > 0) {
    var startHour, endHour;
    if (openHourJsonData != null && openHourJsonData.length > 0) {
      for (let i = 0; i < openHourJsonData.length; i++) {
        var item = openHourJsonData[i];
        if (item.day == week && item.type == type) {
          startHour = item.startHour;
          endHour = item.endHour;
          break;
        }
      }
    }
	
	// 原代码改不动 重新写
	var startIdx = getIdxByTime(startHour);
	var endIdx = getIdxByTime(endHour);
	var nowTime = getNowTimeStr(false);
	var nowIdx = getIdxByTime(getNowTimeStr(true));
	var nowDay = getDateStr(0);
	
	if(nowDay == orderDate){
		if(nowIdx <= startIdx){
			for(let i = startIdx ; i <= (endIdx - _orderHoursMinIdx);i++){
				t.push(getTimeByIdx(i));
			}
		}else if((nowIdx + _orderHoursMinIdx) <= endIdx){
			t.push(nowTime);
			for(let i = nowIdx ; i <= (endIdx - _orderHoursMinIdx);i++){
				t.push(getTimeByIdx(i));
			}
		}
		if((nowIdx + _orderHoursMinIdx) >= endIdx){
			succ(t);
			return;
		}
	}else{
		for(let i = startIdx ; i <= (endIdx - _orderHoursMinIdx);i++){
			t.push(getTimeByIdx(i));
		}
	}
	
	//原代码
 //    var startMM = startHour.substring(3, 5);
 //    var startHH = Number(startHour.substring(0, 2));
 //    var endHH = Number(endHour.substring(0, 2));
 //    var endMM = endHour.substring(3, 5);
 //    var today = dateAhead(1)[0];
 //    var _nowHour = parseInt(today["hour"], 10);
 //    var _nowMinutes = parseInt(today["minutes"], 10);

 //    if (startMM == "30") {
 //      if (startHH > _nowHour || getDateStr(0) != orderDate) {
 //          t.push(startHour);
 //      }
 //      for (var i = (startHH + 1); i <= endHH; i++) {
 //          if (i > _nowHour || getDateStr(0) != orderDate) {
 //              t.push(prefix(i) + ":00");
 //              t.push(prefix(i) + ":30");
 //          }
 //      }
 //    } else {
 //      for (var i = startHH; i <= endHH; i++) {
 //          if (i > _nowHour || getDateStr(0) != orderDate) {
 //              t.push(prefix(i) + ":00");
 //              t.push(prefix(i) + ":30");
 //          }
 //      }
 //    }

 //    if (endMM == "00") {
 //      t.pop();
 //    }
	
	// var nowTime = getNowTimeStr(false);
	// if((getDateStr(0) == obj.orderDate) && t && t.length > 0 && nowTime != t[0]){
	// 	t.unshift(nowTime);
	// }
  }
  succ(t);
}


Seat.loadEndTime = function (obj,succ) {
  let orderDate = obj.orderDate;   //2020-1-20
  let type = 1;   //1
  let openHourJsonData = obj.openHourJsonData;
  let startHourStr = obj.startHourStr;  //15:00
  var week = getMyDay(orderDate);
  var t = [];
  if (type > 0){
    var startFullMinites = getFullMinutes(startHourStr);
    var orderMinitesMin = 60 * Number(_orderHoursMin);
    var orderMinitesMax = 60 * Number(_orderHoursMax);
    var startHour, endHour;
    if (openHourJsonData != null && openHourJsonData.length > 0) {
      for (let i = 0; i < openHourJsonData.length; i++) {
        var item = openHourJsonData[i];
        if (item.day == week && item.type == type) {
          startHour = item.startHour;
          endHour = item.endHour;
          break;
        }
      }
    }
	// 原代码改不动 重新写
	var startIdx = getIdxByTime(startHourStr);
	var endIdx = getIdxByTime(endHour);
	for(let i = (startIdx + _orderHoursMinIdx);i<=endIdx;i++){
		t.push(getTimeByIdx(i));
	}

	
	// 原代码
    // let startMM = startHour.substring(3, 5);
    // var today = dateAhead(1)[0];
    // var _nowHour = parseInt(today["hour"], 10);

    // let startHH = Number(startHour.substring(0, 2));
    // let endHH = Number(endHour.substring(0, 2));
    // var forStartHH;
    // if (startMM == "30") {
    //   forStartHH = startHH + 1;
    // } else {
    //   forStartHH = startHH;
    // }
    // for (var i = forStartHH; i <= endHH; i++) {
    //   if (((getFullMinutes(prefix(i) + ":00") - startFullMinites) >= orderMinitesMin &&
    //     (getFullMinutes(prefix(i) + ":00") - startFullMinites) <= orderMinitesMax &&
    //     (getFullMinutes(prefix(i) + ":00") - startFullMinites) % 60 == 0 &&
    //     getFullMinutes(prefix(i) + ":00") <= getFullMinutes(endHour)) ||
    //     ((getFullMinutes(prefix(i) + ":00") - startFullMinites) <= orderMinitesMax &&
    //       getFullMinutes(prefix(i) + ":00") == getFullMinutes(endHour))) {
    //     t.push(prefix(i) + ":00");
    //   }
    //   if (((getFullMinutes(prefix(i) + ":30") - startFullMinites) >= orderMinitesMin &&
    //     (getFullMinutes(prefix(i) + ":30") - startFullMinites) <= orderMinitesMax &&
    //     (getFullMinutes(prefix(i) + ":30") - startFullMinites) % 60 == 0 &&
    //     getFullMinutes(prefix(i) + ":30") <= getFullMinutes(endHour)) ||
    //     ((getFullMinutes(prefix(i) + ":30") - startFullMinites) <= orderMinitesMax &&
    //       getFullMinutes(prefix(i) + ":30") == getFullMinutes(endHour))) {
    //     t.push(prefix(i) + ":30");
    //   }
    // }
  }
  succ(t);
}


Seat.loadTypeList = function (obj,succ) {
  let orderDate = obj.orderDate;
  let openHourJsonData = obj.openHourJsonData;
  var today = dateAhead(1)[0],
    _nowHour = parseInt(today["hour"], 10),
    _nowMinutes = parseInt(today["minutes"], 10);
  var week = getMyDay(orderDate);
  var d = [];
  if (openHourJsonData != null && openHourJsonData.length > 0) {
    for (let i = 0; i < openHourJsonData.length; i++) {
      var item = openHourJsonData[i];

      if (item.day == week) {
        if (getDateStr(0) != orderDate) {
          d.push({'name':item.typeName,'value':item.type});
        } else {
          let endHour = item.endHour;
          _nowHour = parseInt(today["hour"], 10);
          _nowMinutes = parseInt(today["minutes"], 10);
          //结束时间前30分钟就不能预定了
          if (getFullMinutes(prefix(_nowHour) + ":" + _nowMinutes) < (getFullMinutes(endHour) - 30)) {
            d.push({'name':item.typeName,'value':item.type});
          }
        }
      }
    }
  }
  succ(d);
}

function getMyDay(dateStr) {
  var dateStr1 = dateStr.replace(/-/g, "/");
  var date = new Date(dateStr1);
  var week;
  if (date.getDay() == 0) week = 7;
  if (date.getDay() == 1) week = 1;
  if (date.getDay() == 2) week = 2;
  if (date.getDay() == 3) week = 3;
  if (date.getDay() == 4) week = 4;
  if (date.getDay() == 5) week = 5;
  if (date.getDay() == 6) week = 6;
  return week;
}
function getDateStr(AddDayCount) {
  var dd = new Date();
  dd.setDate(dd.getDate() + AddDayCount);
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1;
  var d = dd.getDate();
  return y + "-" + m + "-" + d;
}
function getFullMinutes(time) {
  // var hour = time.substring(0, 2);
  // var min = time.substring(3, 5);
  var hour = time.split(':')[0];
  var min = time.split(':')[1];
  var fullminites = Number(hour) * 60 + Number(min);
  return fullminites;
}

function getNowTimeStr(isH) {
  var dd = new Date();
  var h = dd.getHours();
  var m = dd.getMinutes();
  if(isH){
	if(m > 30){
		h = h + 1;
		m = 0;
	}else{
		m = 30;  
	}
  }
  h = h < 10 ? '0'+h : h;
  m = m < 10 ? '0'+m : m;
  return h + ":" + m;
}

function prefix(n) {
  return n.toString().length < 2 ? "0" + n : n;
}

function getIdxByTime(time){
	var arr = time.split(":");
	if(!arr || arr.length != 2){
		return 0;
	}
	var idx = arr[0] * 2;
	var mInt = parseInt(arr[1]);
	if(mInt > 30){
		idx += 2;
	}else if(mInt > 0){
		idx++;
	}
	return idx;
}
function getTimeByIdx(idx){
	var time = '';
	if (idx % 2 == 0) {
	    time = (idx / 2) + ":00";
	} else {
	    time = ((idx - 1) / 2) + ":30";
	}
	if(idx <20){
	    time = '0'+time;
	}else {
	    time = time;
	}
	return time;
}


Seat.getAhead = function(acount,succ) {
  if(!_orderHoursMax || !_orderHoursMin){
    _orderHoursMin = 1;
    _orderHoursMax = 8;
  }
  let aheadCount = acount || 7;
  let d = [];
  let daah = dateAhead(aheadCount);
  for (let i = 0, len = daah.length; i < len; i++) {
    let item = daah[i];
    let dStr = item["month"] + "月" + item["day"] + "日 " + relDate(i, item["week"]),
        dVal = item["year"] + "-" + item["month"] + "-" + item["day"];
    d.push({'name':dStr,'value':dVal});
  }
  succ(d);
}

function dateAhead(days) {
  var mill = _NOW * 1;
  var ahead = [];
  for (var i = 0; i < days; i++) {
    var aheadMill = mill + 24 * 60 * 60 * 1000 * i;
    var aheadDate = formatDate(aheadMill);
    ahead.push(aheadDate);
  }
  return ahead;
}

function formatDate(mill) {
  var d = new Date(mill);
  var year = d.getFullYear(),
    month = d.getMonth() + 1,
    day = d.getDate(),
    week = d.getDay();
  var hour = d.getHours(),
    minutes = d.getMinutes();
  return {
    year: year,
    month: month,
    day: day,
    week: week,
    hour: hour,
    minutes: minutes
  }
}
function relDate(i, week) {
  var map = ["日", "一", "二", "三", "四", "五", "六"];
  var rel = "";
  if (i == 0)
    rel = "(今天)"
  else if (i == 1)
    rel = "(明天)"
  else
    rel = "(周" + map[parseInt(week)] + ")";
  return rel;
}

export default Seat;
